module.exports = __webpack_public_path__ + "img/theme10.a9ce1305.png";